// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface TimelineIconSignature {
  Element: SVGSVGElement;
}

export const TimelineIcon: TOC<TimelineIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.9 4.9C6.8 3.1 9.3 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12H4C4 16.4 7.6 20 12 20C16.4 20 20 16.4 20 12C20 7.6 16.4 4 12 4C9.8 4 7.8 4.9 6.4 6.4L9 9H3V3L4.9 4.9ZM10.9 5.8H12.8V11.4L16.1 13.6L15 15.3L10.9 12.5V5.8Z"/>
</svg>
</template>;